export default __webpack_public_path__ + "static/media/icon-ajout-cata-ephemere.d3b46eeb.svg";